import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiKeysApi } from '../api/api-keys-api';

import { apiKeyKeys } from './api-key-keys';

export function apiKeysQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: apiKeyKeys.list(storeId),
    queryFn: () => apiKeysApi.list(storeId),
  });
}

export function useApiKeys(storeId: string) {
  return useQuery(apiKeysQueryOptions(storeId));
}
